var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTurnover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1719 17.2939H37.8343V41.8651H10.1719V17.2939Z",
    fill: "#626C78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2793 21.2109H14.1209V37.9581H8.2793V21.2109Z",
    fill: "#F7F7F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1218 21.211L15.7154 18.3838H6.69141L8.28021 21.211H14.1218Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69141 37.9531H15.7154V40.7755H6.69141V37.9531Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6496 22.2716V36.8876C11.6496 37.1324 11.448 37.334 11.2032 37.334C10.9536 37.334 10.752 37.1324 10.752 36.8876V22.2716C10.752 22.0268 10.9536 21.8252 11.2032 21.8252C11.448 21.8252 11.6496 22.0268 11.6496 22.2716Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2667 22.2716V36.8876C13.2667 37.1324 13.0651 37.334 12.8203 37.334C12.5707 37.334 12.3691 37.1324 12.3691 36.8876V22.2716C12.3691 22.0268 12.5707 21.8252 12.8203 21.8252C13.0651 21.8252 13.2667 22.0268 13.2667 22.2716Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0324 22.2716V36.8876C10.0324 37.1324 9.83076 37.334 9.58116 37.334C9.33636 37.334 9.13477 37.1324 9.13477 36.8876V22.2716C9.13477 22.0268 9.33636 21.8252 9.58116 21.8252C9.83076 21.8252 10.0324 22.0268 10.0324 22.2716Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0762 21.2109H26.9178V37.9581H21.0762V21.2109Z",
    fill: "#F7F7F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9235 21.211L28.5123 18.3838H19.4883L21.0771 21.211H26.9235Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4883 37.9531H28.5123V40.7755H19.4883V37.9531Z",
    fill: "#E5E5E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4464 22.2716V36.8876C24.4464 37.1324 24.2448 37.334 24 37.334C23.7504 37.334 23.5488 37.1324 23.5488 36.8876V22.2716C23.5488 22.0268 23.7504 21.8252 24 21.8252C24.2496 21.8252 24.4464 22.0268 24.4464 22.2716Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0636 22.2716V36.8876C26.0636 37.1324 25.862 37.334 25.6172 37.334C25.3676 37.334 25.166 37.1324 25.166 36.8876V22.2716C25.166 22.0268 25.3676 21.8252 25.6172 21.8252C25.862 21.8252 26.0636 22.0268 26.0636 22.2716Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8292 22.2716V36.8876C22.8292 37.1324 22.6276 37.334 22.378 37.334C22.1332 37.334 21.9316 37.1324 21.9316 36.8876V22.2716C21.9316 22.0268 22.1332 21.8252 22.378 21.8252C22.6324 21.8252 22.8292 22.0268 22.8292 22.2716Z",
    fill: "#E5E5E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8789 21.2109H39.7205V37.9581H33.8789V21.2109Z",
    fill: "#F7F7F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7204 21.211L41.3092 18.3838H32.2852L33.8788 21.211H39.7204Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2852 37.9531H41.3092V40.7755H32.2852V37.9531Z",
    fill: "#E5E5E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2472 22.2716V36.8876C37.2472 37.1324 37.0456 37.334 36.8008 37.334C36.5512 37.334 36.3496 37.1324 36.3496 36.8876V22.2716C36.3496 22.0268 36.5512 21.8252 36.8008 21.8252C37.0456 21.8252 37.2472 22.0268 37.2472 22.2716Z",
    fill: "#E5E5E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8605 22.2716V36.8876C38.8605 37.1324 38.6589 37.334 38.4141 37.334C38.1645 37.334 37.9629 37.1324 37.9629 36.8876V22.2716C37.9629 22.0268 38.1645 21.8252 38.4141 21.8252C38.6637 21.8252 38.8605 22.0268 38.8605 22.2716Z",
    fill: "#E5E5E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M35.63 22.2716V36.8876C35.63 37.1324 35.4284 37.334 35.1788 37.334C34.934 37.334 34.7324 37.1324 34.7324 36.8876V22.2716C34.7324 22.0268 34.934 21.8252 35.1788 21.8252C35.4284 21.8252 35.63 22.0268 35.63 22.2716Z",
    fill: "#E5E5E5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13672 15.9648H42.8647V18.3888H5.13672V15.9648Z",
    fill: "#DDD7D7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13672 40.7754H42.8647V43.1994H5.13672V40.7754Z",
    fill: "#3C4B59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0007 4.7998L5.13672 15.9646H42.8647L24.0007 4.7998Z",
    fill: "#F7F7F7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.888 10.8525C19.584 10.8525 20.016 11.1549 20.016 11.6397C20.016 11.9805 19.8096 12.2493 19.4688 12.3357C19.8768 12.4125 20.1264 12.7197 20.1264 13.1325C20.1264 13.6749 19.6704 14.0061 18.936 14.0061H17.4336V10.8477H18.888V10.8525ZM18.1488 12.1245H18.8544C19.1184 12.1245 19.2864 11.9949 19.2864 11.7741C19.2864 11.5581 19.1184 11.4381 18.8544 11.4381H18.1488V12.1245ZM18.1488 13.4301H18.8544C19.1904 13.4301 19.3968 13.2909 19.3968 13.0461C19.3968 12.8157 19.1952 12.6765 18.8544 12.6765H18.1488V13.4301Z",
    fill: "#61BE7A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2731 13.3965L21.0235 14.0109H20.2891L21.6619 10.8525H22.3963L23.7451 14.0109H22.9819L22.7323 13.3965H21.2731ZM22.0075 11.5965L21.5083 12.8253H22.5067L22.0075 11.5965Z",
    fill: "#61BE7A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2851 14.0109L24.7539 11.9853V14.0109H24.0723V10.8525H24.7203L26.2563 12.8829V10.8525H26.9331V14.0109H26.2851Z",
    fill: "#61BE7A"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7992 12.7245L28.3432 13.2285V14.0109H27.6328V10.8525H28.3432V12.2877L29.6584 10.8525H30.484L29.2984 12.1677L30.5656 14.0061H29.7064L28.7992 12.7245Z",
    fill: "#61BE7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurnover);
export default __webpack_public_path__ + "static/media/turnover.c6eb89752328d89433b5fc48a0a45533.svg";
export { ForwardRef as ReactComponent };